export default "__VITE_ASSET__3551a2a7__"